import { UploadLightIcon } from "../../../../assets";
import type { DataGridColumnDefinition, DataGridCursorDataLoadEventHandler } from "../../../../widget";
import { Button, CursorDataGrid, Divider, FlyoutPanel, ReadonlyText } from "../../../../widget";

export interface DealDocumentDetailsPanelProps {
  show: boolean;
  onClose: () => void;
  documentType?: string;
  documentVariant?: string;
  historyColumns: DataGridColumnDefinition[];
  historyLoading: boolean;
  onHistoryChange: DataGridCursorDataLoadEventHandler;
}

export const DealDocumentDetailsPanel = ({
  show,
  onClose,
  documentType,
  documentVariant,
  historyColumns,
  historyLoading,
  onHistoryChange,
}: DealDocumentDetailsPanelProps): JSX.Element | null => {
  return (
    <FlyoutPanel
      show={show}
      onClose={onClose}
      size="Large"
      header="Document details"
      buttonsChildren={
        <Button
          text="Upload new version"
          variant="primary"
          size="small"
          corners="rounded"
          icon={<UploadLightIcon />}
          iconPosition="left"
          className="DealDocumentDetailsUpload"
        />
      }
      contentChildren={
        <div className="DealDocumentDetailsContent">
          <p className="body2Light">The document versions of this document type and variant are shown here.</p>
          <div className="DealDocumentDetailsMeta">
            <ReadonlyText label="Document type" value={documentType || "--"} />
            <ReadonlyText label="Document variant" value={documentVariant || "--"} />
          </div>
          <Divider type="horizontal" className="DealDocumentDetailsDivider" />
          <h3 className="DealDocumentDetailsHistoryTitle">Version history</h3>
          <div className="DealDocumentDetailsGrid">
            <CursorDataGrid
              columns={historyColumns}
              data={[]}
              clientSide={false}
              filterable
              showFilterToggle
              onChange={onHistoryChange}
              pageable
              showTotalCount={false}
              hasNoPadding
              hasBottomMargin={false}
              noDataMessage="No documents to display"
              dataIsLoading={historyLoading}
              variant="seed"
              pagination={{ pageSize: 10 }}
            />
          </div>
        </div>
      }
    />
  );
};
